import Vue from 'vue';
import TitleIconItem from '@/common/interfaces/TitleIconItem'
import { Component } from 'vue-property-decorator';
const TitleIconProps = Vue.extend({
  props: {
    Icon: Object as () => TitleIconItem,
  },
});

@Component({})
export default class TitleIconComponent extends TitleIconProps {

  get alt() {
    return `${this.Icon.Title} icon`;
  }

  get path() {
    return this.Icon.Path;
  }
}
